var OnlySpacesValidation = /** @class */ (function () {
    function OnlySpacesValidation() {
    }
    OnlySpacesValidation.validate = function (control) {
        var value = control.value;
        if (value && value.length > 0 && value.trim().length === 0) {
            return { onlySpaces: true };
        }
        return null;
    };
    return OnlySpacesValidation;
}());
export { OnlySpacesValidation };
